import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import "react-phone-input-2/lib/style.css";
import { logger } from "../utils/utils";
import queryString from "query-string";
import config from "../config";
import Loader from "../utils/Loader";
import { parseJwt } from "../utils/utils";

function SubirImagenesLocal({ history, match }) {
  const dispatch = useDispatch();
  const queryStringParams = queryString.parse(history.location.search);
  const modelLocal = useSelector((state) => state.localById);

  const modelEliminacionImgLocal = useSelector((state) => {
    logger.debug("useSelector.state", state);
    logger.debug(
      "useSelector.state.modelEliminacionImgLocal",
      state.eliminacionImgLocal
    );
    return state.eliminacionImgLocal;
  });

  const modelEliminacionImgBannerLocal = useSelector((state) => {
    logger.debug("useSelector.state", state);
    logger.debug(
      "useSelector.state.modelEliminacionImgBannerLocal",
      state.eliminacionImgBannerLocal
    );
    return state.eliminacionImgBannerLocal;
  });

  const [imagenes, setImagenes] = useState([]);
  const [imagenesBanner, setImagenesBanner] = useState([]);
  const [localId, setLocalId] = useState(
    match.params.localId ? match.params.localId : null
  );

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      return history.push("/logout");
    }

    const decodedToken = parseJwt(token);

    dispatch(controller.localByIdThunk(localId));
  }, []);

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckLocalById.actions.clear());
    }
    if (data && data.data) {
      logger.debug({ "useEffect.modelLocal.data": data });
      setImagenes(data.data.imagenes);
      setImagenesBanner(data.data.imagenesBanner);
      dispatch(controller.duckLocalById.actions.clear());
    }
  }, [modelLocal]);

  useEffect(() => {
    logger.debug(
      "Local.useEffect(modelEliminacionImgLocal)",
      modelEliminacionImgLocal
    );

    // TODO usar "selectors" para data y error

    const data = modelEliminacionImgLocal?.data?.data?.data;
    const error = modelEliminacionImgLocal?.error;
    const errorMessage =
      modelEliminacionImgLocal?.error?.response?.data?.mensaje;

    logger.debug(
      "useEffect.modelEliminacionImgLocal",
      modelEliminacionImgLocal
    );

    if (error) {
      if (errorMessage) {
        alert(errorMessage);
      }
      // setImagenesListaLoading(false);
      dispatch(controller.duckLocalById.actions.clear());
    }

    if (data) {
      logger.debug("Se pudo eliminar", data);
      dispatch(controller.localByIdThunk(localId));
    }
  }, [modelEliminacionImgLocal, localId, dispatch]);

  useEffect(() => {
    logger.debug(
      "Local.useEffect(modelEliminacionImgBannerLocal)",
      modelEliminacionImgBannerLocal
    );

    // TODO usar "selectors" para data y error

    const data = modelEliminacionImgBannerLocal?.data?.data?.data;
    const error = modelEliminacionImgBannerLocal?.error;
    const errorMessage =
      modelEliminacionImgBannerLocal?.error?.response?.data?.mensaje;

    logger.debug(
      "useEffect.modelEliminacionImgBannerLocal",
      modelEliminacionImgBannerLocal
    );

    if (error) {
      if (errorMessage) {
        alert(errorMessage);
      }
      // setImagenesListaLoading(false);
      dispatch(controller.duckLocalById.actions.clear());
    }

    if (data) {
      logger.debug("Se pudo eliminar", data);
      dispatch(controller.localByIdThunk(localId));
    }
  }, [modelEliminacionImgBannerLocal, localId, dispatch]);

  const navegarASubirImagen = () => {
    logger.debug("navigateToSubirImagenes");

    const token = localStorage.getItem("token");

    const baseUrl = config.api.baseUrl;
    const key = config.api.key;

    const concepto = "local";
    const conceptoId = localId;

    logger.debug({ concepto });
    logger.debug({ config });
    logger.debug({
      imgRestrictionsByConcepto: config.imgRestrictionsByConcepto[concepto],
    });

    const uploadConfigVariant = "upload";
    const cropConfigVariant = "crop";

    const uploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=true&configVariant=${uploadConfigVariant}`;
    const uploadHeaders = {
      "x-access-token": key,
    };

    const cropUploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=false&configVariant=${cropConfigVariant}`;
    const cropConfig =
      config.imgRestrictionsByConcepto[concepto][cropConfigVariant];

    const nextStepUrl = `/cortarImagenes`;
    const lastStepUrl = `/subirImagenesLocal/${localId}`;

    const params = queryString.stringify({
      conceptoId,
      concepto,
      uploadUrl,
      rawUploadHeaders: JSON.stringify(uploadHeaders),
      nextStepUrl,
      pageTitle: "Subir imagen de perfil para local",
      pageSubtitle: "Paso 1 : Subida",
      nextButtonText: "Siguiente",
      cropConfig: JSON.stringify(cropConfig),
      cropUploadUrl,
      saveInConceptUrl: `${baseUrl}/agregarImagenALocal`,
      lastStepUrl,
      cancelUrl: `/editLocal/${localId}`,
      ...config.imgRestrictionsByConcepto[concepto][uploadConfigVariant],
    });

    logger.debug("EditServicioHijo.paramsBeforeNavigate");
    logger.debug(params);

    history.push(`/subirImagenes?${params}`);
  };

  const navegarASubirImagenBanner = () => {
    logger.debug("navegarASubirImagenBanner");

    const token = localStorage.getItem("token");

    const baseUrl = config.api.baseUrl;
    const key = config.api.key;

    const concepto = "localBanner";
    const conceptoId = localId;

    logger.debug({ concepto });
    logger.debug({ config });
    logger.debug({
      imgRestrictionsByConcepto: config.imgRestrictionsByConcepto[concepto],
    });

    const uploadConfigVariant = "upload";
    const cropConfigVariant = "crop";

    const uploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=true&configVariant=${uploadConfigVariant}`;
    const uploadHeaders = {
      "x-access-token": key,
    };

    const cropUploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=false&configVariant=${cropConfigVariant}`;
    const cropConfig =
      config.imgRestrictionsByConcepto[concepto][cropConfigVariant];

    const nextStepUrl = `/cortarImagenes`;
    const lastStepUrl = `/subirImagenesLocal/${localId}`;

    const params = queryString.stringify({
      conceptoId,
      concepto,
      uploadUrl,
      rawUploadHeaders: JSON.stringify(uploadHeaders),
      nextStepUrl,
      pageTitle: "Subir imagen de perfil para local",
      pageSubtitle: "Paso 1 : Subida",
      nextButtonText: "Siguiente",
      cropConfig: JSON.stringify(cropConfig),
      cropUploadUrl,
      saveInConceptUrl: `${baseUrl}/agregarImagenBannerALocal`,
      lastStepUrl,
      cancelUrl: `/editLocal/${localId}`,
      ...config.imgRestrictionsByConcepto[concepto][uploadConfigVariant],
    });

    logger.debug("EditServicioHijo.paramsBeforeNavigate");
    logger.debug(params);

    history.push(`/subirImagenes?${params}`);
  };

  const doEliminarImagen = (imagenID) => {
    const token = localStorage.getItem("token");
    // setImagenesListaLoading(true);
    logger.debug("doEliminarImagen.imagenID", imagenID);
    logger.debug("doEliminarImagen.localId", localId);
    let data = {
      imagenID,
      localId: localId,
      token,
    };
    dispatch(controller.eliminarImgLocalThunk(data));
  };

  const doEliminarImagenBanner = (imagenID) => {
    const token = localStorage.getItem("token");
    // setImagenesListaLoading(true);
    logger.debug("doEliminarImagenBanner.imagenID", imagenID);
    logger.debug("doEliminarImagenBanner.localId", localId);
    let data = {
      imagenID,
      localId: localId,
      token,
    };
    dispatch(controller.eliminarImgBannerLocalThunk(data));
  };

  return (
    <Content
      title="Subir imágenes para local"
      browserTitle="Local - Imágenes"
      show={false}
    >
      <Row className="marginBottom20px">
        <Col md="6" mdOffset="3" lg="4" lgOffset="4">
          <div>
            <h4>Imagen de perfil:</h4>
          </div>

          {imagenes && Array.isArray(imagenes) && imagenes.length
            ? imagenes.map((imagenObj, index) => {
                logger.debug(
                  "ImagenesLista.render.imagenes.map.imagenObj",
                  imagenObj
                );
                return (
                  <Box>
                    <div style={{ marginBottom: 20 }}>
                      <p>
                        <b>Nombre de archivo:</b>
                        <br />
                        {imagenObj.url.split("/").pop()}
                      </p>
                      <a href={imagenObj.url}>Ver imagen</a>
                    </div>
                    <Button
                      type="default"
                      text="Eliminar"
                      pullRight={true}
                      onClick={() => doEliminarImagen(imagenObj._id)}
                    />
                  </Box>
                );
              })
            : "Sin imagen de perfil"}

          <Button
            pullRight={true}
            type="primary"
            text="Subir imagen de perfil"
            onClick={navegarASubirImagen}
            className="minWidth200px"
          />
        </Col>
      </Row>
      <Row>
        <Col md="6" mdOffset="3" lg="4" lgOffset="4">
          <div>
            <h4>Imagen de banner:</h4>
          </div>

          {imagenesBanner &&
          Array.isArray(imagenesBanner) &&
          imagenesBanner.length
            ? imagenesBanner.map((imagenObj, index) => {
                logger.debug(
                  "ImagenesLista.render.imagenes.map.imagenObj",
                  imagenObj
                );
                return (
                  <Box>
                    <div style={{ marginBottom: 20 }}>
                      <p>
                        <b>Nombre de archivo:</b>
                        <br />
                        {imagenObj.url.split("/").pop()}
                      </p>
                      <a href={imagenObj.url}>Ver imagen</a>
                    </div>
                    <Button
                      type="default"
                      text="Eliminar"
                      pullRight={true}
                      onClick={() => doEliminarImagenBanner(imagenObj._id)}
                    />
                  </Box>
                );
              })
            : "Sin imagen de banner"}
          <Button
            pullRight={true}
            type="primary"
            text="Subir imagen de banner"
            onClick={navegarASubirImagenBanner}
            className="minWidth200px"
          />
        </Col>
      </Row>
      <Row>
        <Col md="6" mdOffset="3" lg="4" lgOffset="4">
          <div style={{ display: "block", marginTop: 40 }}>
            <Button
              pullRight={false}
              block={true}
              type="primary"
              text="Finalizar"
              onClick={() => {
                const url = queryStringParams.urlAlFinalizar
                  ? queryStringParams.urlAlFinalizar
                  : "/";
                history.push(url);
              }}
              className="minWidth200px"
            />
          </div>
        </Col>
      </Row>
    </Content>
  );
}

export default SubirImagenesLocal;
